"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Link } from "react-router";
import { Range } from "immutable";
function currentPage(props) {
  return Math.min(
    ...[parseInt(props.location.query.page || "1"), props.numberOfPages]
  );
}
function pageWindow(props) {
  var startPage = currentPage(props);
  var lastPage = props.numberOfPages;
  var windowSize = props.windowSize || 15;
  if (lastPage <= windowSize) {
    return Range(1, lastPage + 1);
  }
  var start = startPage - Math.floor(windowSize / 2);
  if (start < 1) {
    start = 1;
  }
  var stop = start + windowSize;
  if (stop > lastPage) {
    stop = lastPage + 1;
    start = Math.max(...[1, stop - windowSize]);
  }
  return Range(start, stop);
}
function showPage(props, page) {
  return /* @__PURE__ */ jsx(
    "li",
    {
      className: classNames({ current: currentPage(props) === page }),
      children: /* @__PURE__ */ jsx(
        Link,
        {
          to: props.location.pathname,
          query: Object.assign({}, props.location.query, { page }),
          children: page
        }
      )
    },
    "page-link-" + page
  );
}
function Paginator(props) {
  var page = currentPage(props);
  var prevClasses = classNames({ arrow: true, unavailable: page <= 1 });
  var nextClasses = classNames({
    arrow: true,
    unavailable: page === props.numberOfPages
  });
  return /* @__PURE__ */ jsxs("ul", { "data-component": "Paginator", className: "pagination", children: [
    /* @__PURE__ */ jsx("li", { className: prevClasses, children: /* @__PURE__ */ jsx(
      Link,
      {
        to: props.location.pathname,
        query: Object.assign({}, props.location.query, {
          page: page - 1
        }),
        children: "\xAB"
      }
    ) }),
    pageWindow(props).map((page2) => showPage(props, page2)),
    /* @__PURE__ */ jsx("li", { className: nextClasses, children: /* @__PURE__ */ jsx(
      Link,
      {
        to: props.location.pathname,
        query: Object.assign({}, props.location.query, {
          page: page + 1
        }),
        children: "\xBB"
      }
    ) })
  ] });
}
export default Paginator;
